import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

import { documentTypes } from './useDocuments';

export const targetTypes = {
    request: "request",
    wallet: "wallet"
}

export const actionTypes = {
    request: {
        transfer: {
            id: 'transfer',
            display: "Transfer"
        },
        topup: {
            id: 'topup',
            display: "Topup"
        },
        withdraw: {
            id: 'withdraw',
            display: "Withdrawal"
        },
    },
    wallet: {
        transfer: {
            id: 'transfer',
            display: "Transfer"
        },
        topup: {
            id: 'topup',
            display: "Topup"
        },
        withdraw: {
            id: 'withdraw',
            display: "Withdrawal"
        },
        payment: {
            id: 'payment',
            display: "Payment"
        },
    },
}

export const destinationTypes = {
    request: {
        transfer: {
            target: "wallet",
            module: "wallet_user",
            transactionRef: "wallet_user",
            refFieldName: "wallet_user_id"
        },
    },
    wallet: {
        transfer: {
            target: "wallet",
            module: "wallet_user",
            transactionRef: "wallet_user",
            refFieldName: "wallet_user_id"
        },
        documentPayment: {
            cashSales: {
                target: "document",
                module: documentTypes.cashSales,
                transactionRef: "document",
                refFieldName: "document_id"
            },
            deliveryOrder: {
                target: "document",
                module: documentTypes.deliveryOrder,
                transactionRef: "document",
                refFieldName: "document_id"
            },
            salesOrder: {
                target: "document",
                module: documentTypes.salesOrder,
                transactionRef: "document",
                refFieldName: "document_id"
            },
            salesInvoice: {
                target: "document",
                module: documentTypes.salesInvoice,
                transactionRef: "document",
                refFieldName: "document_id"
            }
        }
    }
}

export const payloadTypes = {
    request: {
        transfer: {
            // id: 'transfer',
            action: "wallet_transfer",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id",

        },
        topup: {
            // id: 'transfer',
            action: "wallet_topup",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id"
        },
        withdraw: {
            // id: 'withdraw',
            action: "wallet_withdraw",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id"
        },
    },
    wallet: {
        transfer: {
            // id: 'transfer',
            action: "transfer",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id",

        },
        topup: {
            // id: 'transfer',
            action: "topup",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id"
        },
        withdraw: {
            // id: 'withdraw',
            action: "withdraw",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id"
        },
        payment: {
            // id: 'payment',
            action: "payment",
            sourceTarget: "wallet",
            sourceModule: "wallet_user",
            transactionRef: "wallet_user",
            sourceRefFieldName: "wallet_user_id",
        },
    }
}

export const updateStatusTypes = {
    pending: "pending",
    approved: "approved",
    cancelled: "cancelled"
}

// // sample payload
// const payload = {
//     source: {
//         target: payloadTypes.wallet.transfer.sourceTarget,
//         module: payloadTypes.wallet.transfer.sourceModule,
//         transactionRef: payloadTypes.wallet.transfer.transactionRef,
//         ref_id: {
//             [payloadTypes.wallet.transfer.sourceRefFieldName]: "100"
//         }
//     },
//     destination: {
//         target: destinationTypes.wallet.transfer.target,
//         module: destinationTypes.wallet.transfer.module,
//         transactionRef: destinationTypes.wallet.transfer.transactionRef,
//         ref_id: {
//             [destinationTypes.wallet.transfer.refFieldName]: "100"
//         }
//     }
// }

export function useTransactions({
    targetType: _targetType
}) {

    // const [rateType, setRateType] = useState(_currencyType);
    const [targetType, setTargetType] = useState(_targetType)

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "transactions";
    const endpoint2 = "transaction";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let { targetType: overrideTargetType } = props

            let url = getListsUrl(`${endpoint}/${targetType}`, props)

            if (overrideTargetType) {
                url = getListsUrl(`${endpoint}/${overrideTargetType}`, props)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const create = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = endpoint2;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    // currently only for request type
    const updateStatus = async ({ id, data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/status/${id}`

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    // const remove = async ({ ids }) => {

    //     setIsLoading(true);

    //     if (ids.length <= 0) {
    //         throw getError(false, `Please select at least (1) items`)
    //     }

    //     try {

    //         let url = `${endpoint}/delete`

    //         const postData = {
    //             scope: {
    //                 target: targetType
    //             },
    //             payload: {
    //                 ids
    //             }
    //         }

    //         const response = await makeCall({
    //             url,
    //             method: "POST",
    //             payload: postData
    //         });

    //         setIsLoading(false);

    //         return response;

    //     } catch (error) {

    //         setIsLoading(false);
    //         throw error;

    //     }

    // }

    const get = async ({ id, targetType: overrideTargetType = '', dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint2}/${targetType}/${id}`, dataTypesArray);

            if (overrideTargetType) {
                url = getUrlWithDataTypes(`${endpoint2}/${overrideTargetType}/${id}`, dataTypesArray);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        list,
        get,
        create,
        updateStatus,
        // remove
    }
}